<svg
  [attr.fill]="style.fill"
  [attr.height]="style.height"
  [attr.width]="style.width"
  [attr.cursor]="style.cursor"
>
  <use [attr.xlink:href]="'../../assets/img/icon.sprites.svg#' + iconName" />
  <!-- <use [attr.xlink:href]="'#'+iconName" /> -->
</svg>
